import { fromJS } from 'immutable';
import { endLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  regulamentacoes: []
});

function regulamentacoesReducer(state = initialState, action) {
  switch (action.type) {
    case types.REGULAMENTACOES_START:
    case types.REGULAMENTACOES_ERROR:
    case types.REGULAMENTACOES_SUCCESS: {
      return endLoad(state.set('regulamentacoes', fromJS(action.payload)));
    }
  }

  return state;
}

export default regulamentacoesReducer;
